export const defaultReconnectChatPaneGeneralStyles = {
  backgroundColor: "rgb(255, 255, 255)",
  borderColor: "#E6E6E6",
  borderRadius: "4px",
  borderStyle: "solid",
  borderWidth: "3px",
  padding: "15px",
  height: "inherit",
  width: "inherit",
  overflowY: "auto"
};